import { render, staticRenderFns } from "./AboutLaBoutiqueSoBook.vue?vue&type=template&id=20b8bf23&scoped=true&"
import script from "./AboutLaBoutiqueSoBook.vue?vue&type=script&lang=js&"
export * from "./AboutLaBoutiqueSoBook.vue?vue&type=script&lang=js&"
import style0 from "./AboutLaBoutiqueSoBook.vue?vue&type=style&index=0&id=20b8bf23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b8bf23",
  null
  
)

export default component.exports